import React from 'react'
import ModalAlert from 'src/components/ModalAlert'

const ModalWriteDescription = ({ show, action }) => (
  <ModalAlert
    show={show}
    action={action}
    title="Preencher descrição"
    message="Código de barras não encontrado. Digite a descrição resumida."
  />
)

export default ModalWriteDescription
